import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import {
    Chat,
    ChatMessage,
    ChatUser,
    Dialog,
    Replayes
} from "@/store/chats";
import { AttachedMessage } from "@/store/chats";


export class ChatsApi {
    // Проверка доступа к чатам
    static getChatsAccess(): Promise<ChatsAccess> {
        const http = new CommonHttp()
        return http
            .get('chats/access')
            .then(data => data.data)
    }

    // Получение всего списка диалогов
    static getAllDialogs():  Promise<Dialog[]> {
        const http = new CommonHttp()
        return http
            .get('chats')
            .then(data => data.data)
    }

    // Создание (отправка) сообщения
    static createMessage(message: CreateMessageModel): Promise<any> {
        const http = new CommonHttp()
        return http
            .post('chats/messages', message)
            .then(data => data.data)
    }

    // Получение обновленного списка сообщений открытого чата (тестовый метод)
    static refreshChatMessagesSecond(chatId: number, lastMessageId: number): Promise<RefreshMessagesResponse> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}/anal/messages/refresh?chatId=${chatId}&lastMessageId=${lastMessageId}`)
            .then(data => data.data)
    }

     // Получение обновленного списка сообщений открытого чата
    static refreshChatMessages(chatId: number, messageDate: string): Promise<RefreshMessagesResponse> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}/messages/refresh?messageDate=${messageDate}`)
            .then(data => data.data)
    }

    // Получение обновленного списка диалогов
    static refreshDialogInList(beforeUpdateDate: string): Promise<Dialog[]> {
        const http = new CommonHttp()
        return http
            .get(`chats/refresh?updateAfter=${beforeUpdateDate}`)
            .then(data => data.data)
    }

    // Получение обновленного списка сообщений открытого чата
    static readMessage(messageId: number): any {
        const http = new CommonHttp()
        return http.get(`chats/messages/${messageId}/read`).then(data => data.data)
    }

    // Получение данных открываемого чата
    static getChat(chatId: number):  Promise<Chat> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}`)
            .then(data => data.data)
    }

    // Получение списка пользователей для создания чата/конференции
    static getChatUsers(personalChatId?: number):  Promise<ChatUser[]> {
        const http = new CommonHttp()
        return http
            .get(`chats/users${personalChatId ? `?personalChatId=${personalChatId}` : ''}`)
            .then(data => data.data)
    }

    // Создание чата с самим собой или другим человеком
    static createChatWithYouOrOneFriend(userId: number):  Promise<{ Id: number }> {
        const http = new CommonHttp()
        return http
            .post(`chats/personal?companionId=${userId}`, null)
            .then(data => data.data)
    }

    // Создание новую конференцию с выбранными пользователями
    static createConferenceWithUsers(conference: ConferenceCreateRequestBody):  Promise<{ Id: number }> {
        const http = new CommonHttp()
        return http
            .post(`chats/conference`, conference)
            .then(data => data.data)
    }

    // Превращение личного чата в группу
    static convertPersonalChatToConference(conference: ConferenceCreateRequestBody | {chatId: number}):  Promise<{ Id: number }> {
        const http = new CommonHttp()
        return http
            .post(`chats/convertToConf`, conference)
            .then(data => data.data)
    }

    // Редактирование группы
    static editConference(conference: ConferenceEditRequestBody):  Promise<{ Id: number }> {
        const http = new CommonHttp()
        return http
            .put(`chats`, conference)
            .then(data => data.data)
    }

    // Покинуть группу
    static exitConference(chatId: number):  Promise<{ Id: number }> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}/exit`)
            .then(data => data.data)
    }

    // Получение предыдущих сообщений
    static getPreviouseMessages(chatId: number, messageDate: string):  Promise<ChatMessage[]> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}/messages/prev?messageDate=${messageDate}`)
            .then(data => data.data)
    }

    // Получение следующих сообщений
    static getNextMessages(chatId: number, messageDate: string):  Promise<ChatMessage[]> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}/messages/next?messageDate=${messageDate}`)
            .then(data => data.data)
    }

    // Удалить диалог
    static deleteDialog(chatId: number):  Promise<void> {
        const http = new CommonHttp()
        return http
            .put(`chats/${chatId}/clearHistory`, null)
            .then(data => data.data)
    }

    // Поиск диалогов
    static searchDialogs(searchedText: string):  Promise<any> {
        const http = new CommonHttp()
        return http.get(`chats/search?searchedText=${searchedText}`)
    }

    // Поиск сообщений
    static searchMessages(searchedText: string):  Promise<any> {
        const http = new CommonHttp()
        return http.get(`chats/messages/search?searchedText=${searchedText}`)
    }

    // Открытие чата из поиска с центровкой на сообщении
    static getChatCenteredOnMessage(chatId: number, messageId: number):  Promise<ChatMessage[]> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}/messages/jumpTo/${messageId}`)
            .then(data => data.data)
    }

    // Поиск сообщений внутри чата
    static searchMessagesInChat(chatId: number, searchText: string):  Promise<ChatMessage[]> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}/messages/search?searchText=${searchText}`)
            .then(data => data.data)
    }

    // Получение списка прикрепленных сообщений
    static getAttachedMessages(messageId: number):  Promise<AttachedMessage[]> {
        const http = new CommonHttp()
        return http
            .get(`chats/messages/${messageId}/attached`)
            .then(data => data.data)
    }

    // Получить настройки чата
    static getChatListReplayes():  Promise<Replayes[]> {
        const http = new CommonHttp()
        return http
            .get(`chats/replayes`)
            .then(data => data.data)
    }

    // Получить настройки чата
    static getChatSettings(chatId: number):  Promise<any> {
        const http = new CommonHttp()
        return http
            .get(`chats/${chatId}/settings`)
            .then(data => data.data)
    }
}

export type ChatsAccess = {
    Allow: boolean
}

export type ConferenceCreateRequestBody = {
    name: string,
    photolink: string,
    workers: number[]
}

export type ConferenceEditRequestBody = {
    chatId: number,
    name: string,
    photolink: string,
    workersToAdd: number[],
    workerToRemove: number[],
}

export type CreateMessageModel = {
    chatId: number,
    text: string,
    attachedMessageIds?: number[],
}

export type RefreshMessagesResponse = {
    Messages: ChatMessage[],
    UnreadCount: number,
    UserCanEdit: boolean,
    UserCanWrite: boolean,
}

export type SearchMessage = {
    ChatId: number,
    Id: number,
    Message: string
    MessageDate: string,
    Name: string,
    PhotoLink: string | null,
    PhotoLiter: string,
    ShowSmallPhoto: boolean,
    SmallPhotoLink: string | null,
    SmallPhotoLiter: string,
    Unreaded: boolean
}

export type SearchDialog = {
    Id: number,
    IsPotential: boolean,
    Name: string,
    PhotoLink: string | null,
    PhotoLiter: string
}
